export const BATCH_UPLOAD_ITEM_GET_URL = 'BATCH_UPLOAD_ITEM_GET_URL';
export const BATCH_UPLOAD_ITEM_GET_URL_FAIL = 'BATCH_UPLOAD_ITEM_GET_URL_FAIL';

export const BATCH_UPLOAD_ITEM_START_MULTIPART = 'BATCH_UPLOAD_ITEM_START_MULTIPART';
export const BATCH_UPLOAD_ITEM_START_MULTIPART_FAIL = 'BATCH_UPLOAD_ITEM_START_MULTIPART_FAIL';

export const BATCH_UPLOAD_ITEM_END_MULTIPART = 'BATCH_UPLOAD_ITEM_END_MULTIPART';
export const BATCH_UPLOAD_ITEM_END_MULTIPART_FAIL = 'BATCH_UPLOAD_ITEM_END_MULTIPART_FAIL';
